export default "__VITE_ASSET__Dax3Owuj__"